import { AhrefScript } from '@scripts/ahrefs'
import { HubSpotScript } from '@scripts/hubspot'

const ThirdPartyScripts = () => (
  <>
    <HubSpotScript />
    <AhrefScript />
  </>
)

export { ThirdPartyScripts }
